import { render, staticRenderFns } from "./OrderReceipts.vue?vue&type=template&id=b5772c6e&scoped=true"
import script from "./OrderReceipts.vue?vue&type=script&lang=js"
export * from "./OrderReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5772c6e",
  null
  
)

export default component.exports